import { render, staticRenderFns } from "./receiveForm.vue?vue&type=template&id=8c9bc87c&"
import script from "./receiveForm.vue?vue&type=script&lang=js&"
export * from "./receiveForm.vue?vue&type=script&lang=js&"
import style0 from "./receiveForm.vue?vue&type=style&index=0&id=8c9bc87c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports